import { Cell, Pie, PieChart, ResponsiveContainer } from "recharts";

const COULEURS = { sains: "#10B981", en_panne: "#EF4444" };

/** Camembert d'état par marque supervisée (Loxone, UNV, UniFi, Reyee). */
export const CamembertMarque = ({ marque, sombre = false }) => {
  const total = marque.sains + marque.en_panne;
  const data = total
    ? [
        { nom: "sains", valeur: marque.sains },
        { nom: "en_panne", valeur: marque.en_panne },
      ].filter((d) => d.valeur > 0)
    : [{ nom: "sains", valeur: 1 }];
  const pourcent = total ? Math.round((marque.sains / total) * 100) : null;

  return (
    <div
      className={`rounded-2xl border p-4 ${sombre ? "border-white/10 bg-white/5" : "border-slate-200 bg-white"}`}
      data-testid={`camembert-${marque.cle}`}
    >
      <div className={`text-sm font-semibold ${sombre ? "text-white" : "text-slate-900"}`}>{marque.label}</div>
      <div className={`text-xs ${sombre ? "text-white/50" : "text-slate-500"}`}>
        {total ? `${total} équipement(s) suivis` : "Aucun matériel enregistré"}
      </div>

      <div className="relative h-32 mt-2">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie data={data} dataKey="valeur" nameKey="nom" innerRadius="62%" outerRadius="92%" stroke="none" isAnimationActive={false}>
              {data.map((d) => (
                <Cell key={d.nom} fill={total ? COULEURS[d.nom] : sombre ? "#1E293B" : "#E2E8F0"} />
              ))}
            </Pie>
          </PieChart>
        </ResponsiveContainer>
        <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none">
          <span
            className={`font-display text-2xl font-black tracking-tighter ${sombre ? "text-white" : "text-slate-900"}`}
            data-testid={`camembert-taux-${marque.cle}`}
          >
            {pourcent === null ? "—" : `${pourcent}%`}
          </span>
          <span className={`text-[10px] uppercase tracking-[0.15em] ${sombre ? "text-white/40" : "text-slate-400"}`}>OK</span>
        </div>
      </div>

      <div className={`flex items-center justify-between text-xs mt-1 ${sombre ? "text-white/60" : "text-slate-500"}`}>
        <span className={marque.en_panne ? "text-red-500 font-semibold" : ""}>
          {marque.en_panne} en panne{marque.critiques ? ` (${marque.critiques} critique)` : ""}
        </span>
        <span>{marque.surveilles ? `${marque.surveilles} pingé(s)` : `${marque.alertes_24h} alerte(s) 24 h`}</span>
      </div>
    </div>
  );
};

export default CamembertMarque;
